"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _x = _interopRequireDefault(require("@ux/icon/x"));
/**
 * Tray close component.
 *
 * @param {React.ComponentProps} props - component props
 * @returns {React.ReactElement} close button.
 * @api public
 */
function TrayClose(props) {
  return /*#__PURE__*/_react.default.createElement("button", {
    className: "tray-close",
    onClick: props.onClick,
    "aria-label": "close"
  }, /*#__PURE__*/_react.default.createElement(_x.default, {
    width: 24,
    height: 24
  }));
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
TrayClose.propTypes = {
  onClick: _propTypes.default.func.isRequired
};
var _default = TrayClose;
exports.default = _default;